import { useRef, useState } from "react";
import { useScroll, useMotionValueEvent, useReducedMotion } from "framer-motion";
import { DisequilibriumVisual } from "@/components/DisequilibriumVisual";

/* What we examined: sticky evolving visual + scroll-activated chapters */
export function ExaminedSequence({ stages }) {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.65", "end 0.75"] });
  const [active, setActive] = useState(0);
  useMotionValueEvent(scrollYProgress, "change", (v) => {
    setActive(Math.min(stages.length - 1, Math.max(0, Math.floor(v * stages.length))));
  });

  return (
    <div ref={ref} className="relative md:grid md:grid-cols-12 md:gap-10" data-testid="examined-sequence">
      <div className="md:col-span-5 mb-10 md:mb-0">
        <div className="md:sticky md:top-32">
          <DisequilibriumVisual progress={reduced ? null : scrollYProgress} assemble={reduced} className="w-full max-w-md" />
          <div className="mt-4 flex items-baseline gap-3">
            <span className="font-serif text-2xl text-ember">{stages[active].n}</span>
            <span className="text-xs tracking-[0.2em] uppercase text-fog">{stages[active].title}</span>
          </div>
        </div>
      </div>
      <div className="md:col-span-7">
        {stages.map((s, i) => (
          <div
            key={s.n}
            data-testid={`examined-stage-${s.n}`}
            className={`min-h-[38vh] md:min-h-[55vh] flex flex-col justify-center transition-opacity duration-700 ${
              i === active ? "opacity-100" : "opacity-35"
            }`}
          >
            <span className="text-[11px] tracking-[0.25em] uppercase text-fog">{s.n}</span>
            <h3 className="font-serif text-2xl md:text-4xl tracking-tight mt-3">{s.title}</h3>
            <p className="mt-4 text-fog leading-relaxed max-w-xl">{s.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
